export function backofficePath(path) {
  const match = window.location.pathname.match(/^\/backoffice\/(\d+)/);
  return match ? `/backoffice/${match[1]}${path}` : `/backoffice${path}`;
}
